import { useState, useEffect } from 'react';

function useSessionStorage() {
    // Get from session storage then
    // parse stored json or if none return initialValue
    const get = () => {
        const storage = window.sessionStorage.getItem('cart');
        if (storage) return JSON.parse(storage);
        else return {
						tags: [],
						total: 0,
						fees: 0,
						discounts: []
				};
    };

    // State to store our value
    const [value, setValue] = useState(get());

    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to sessionStorage.
    const set = (value) => {
        window.sessionStorage.setItem('cart', JSON.stringify(value));
        setValue(value);
    };

    return [value, set];
}

export default useSessionStorage;